module.exports = __webpack_public_path__ + "static/web_autistica_case-min-ea2aa41c0cb787bd3b2d0a5b2ab39aa2.png";